import { createSlice } from "@reduxjs/toolkit";

const customerListingReducer = createSlice({
  name: 'customerListing',
  initialState: {
    queryParams: {
      sort_by: null,
      sort_order: null,
      search: null,
      page: 1,
      per_page: 25
    }
  },
  reducers: {
    setQueryParams: (state, action) => {
      const { queryParams } = action.payload;
      state.queryParams = queryParams;
    },
    updateQueryParams: (state, action) => {
      const { queryParams } = action.payload;
      if (queryParams && queryParams.search) {
        state.queryParams = { ...state.queryParams, ...queryParams, search: queryParams.search, page: 1 }
      } else {
        state.queryParams = { ...state.queryParams, ...queryParams };
      }
    },
    resetQueryParams: (state, action) => {
      state.queryParams = {
        sort_by: null,
        sort_order: null,
        search: null,
        page: 1,
        per_page: 25,
      }
    },
    resetFiltersparams: (state, action) => {
      state.queryParams = {...state.queryParams, filters:{}}
    },
    resetTabQueryParams: (state, action) => {
      if (action.payload && (action.payload.search || action.payload.sort_by)) {
        state.queryParams = { ...state.queryParams, search: null, sort_by: null, page: 1 };
      }
      state.queryParams = {
        sort_by: null,
        sort_order: null,
        search: null,
        page: 1,
        per_page: 25,
      }
    }
  }
});
export const { setQueryParams, updateQueryParams, resetFiltersparams, resetQueryParams, resetTabQueryParams } = customerListingReducer.actions;

export default customerListingReducer.reducer;

export const selectQueryParams = (state) => {
  return state.ui.customerListing.queryParams;
}

export const sortUpdated = (sort_by, sort_order) => {
  return {
    queryParams: {
      sort_by: sort_by,
      sort_order: sort_order
    }
  }
}

export const paginationUpdated = (page, per_page) => {
  return {
    queryParams: {
      page: page,
      per_page: per_page
    }
  }
}

export const searchUpdated = (searchText) => {
  return {
    queryParams: {
      search: searchText
    }
  }
}

export const perPageUpdated = (perPage) => {
  return {
    queryParams: {
      per_page: perPage,
      page: 1
    }
  }
}

export const pageUpdated = (page) => {
  return {
    queryParams: {
      page: page
    }
  }
}

export const defaultQueryParams = (defaultFilters) => {
  return {
    queryParams: {
      sort_by: null,
      search: null,
      sort_order: 'desc',
      page: 1,
      per_page: 25,
      filters: defaultFilters
    }
  }
}
